module.exports = __webpack_public_path__ + "img/connector.0a8c1849.png";